export default "__VITE_ASSET__d9000e98__"